'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'narwhal';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'f6fe';
var svgPathData = 'M630 34.5L580.6 204.6c-.5-.5-1.1-1-1.6-1.4c37.3 32.3 61 79.8 61 132.8c0 97.2-78.8 176-176 176l-240 0c-88.4 0-160-71.6-160-160l0-98.9-57.2-40L0 208.3 0 200l0-88 0-11.2L0 81.3 16 92.5l9.2 6.4L96 148.5l70.8-49.6 9.2-6.4 16-11.2 0 19.5 0 11.2 0 88 0 8.3-6.8 4.8-57.2 40 0 94.3 0 20.6 16-13L322.9 209.6c39.5-32.1 89.3-49.6 140.2-49.6c9.4 0 18.7 .7 27.7 2.2L615.7 26.5 640 0 630 34.5zM509 166c21.2 5.7 40.8 15.2 58.1 27.7L605.6 61 509 166zM96 168l-9.2-6.4L16 112l0 88 57.2 40 6.8 4.8 0 8.3L80 352c0 79.5 64.5 144 144 144l240 0c88.4 0 160-71.6 160-160c0-88.3-72.4-160-160.9-160c-47.3 0-93.4 16.3-130.1 46L138.1 380.4 112 401.6l0-33.6 0-114.9 0-8.3 6.8-4.8L176 200l0-88-70.8 49.6L96 168zM480 304a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faNarwhal = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;